// extracted by mini-css-extract-plugin
module.exports = {"card":"getting-started-steps_card__3ovFi","active":"getting-started-steps_active__1-v2v","title":"getting-started-steps_title__Ldqsd","check":"getting-started-steps_check__20RIf"};